<!--let loader: Loader = loader$ | async-->

@if (loaderService.loader().loading) {
  <section class="overlay">
    <mat-progress-spinner
      class="overlay__spinner"
      diameter="57"
      color="primary"
      mode="indeterminate"
      strokeWidth="2"
    ></mat-progress-spinner>

    @if (!!loaderService.loader().loadingMsg) {
      <p class="overlay__paragraph">{{ loaderService.loader().loadingMsg }}</p>
    }
  </section>
}
